import { Text } from 'react-native';

const heatmap = (number) => {
	let value = '';
	let cop = 255 - Math.floor(((number - 1) / 98) * 255);
	if (cop > 210) cop = 200;
	const color = 'rgb(' + cop + ', ' + cop + ', ' + cop + ')'

	//100 + Math.floor(((number - 1) / (99 - 1) * (999 - 100)))
	let cap = Math.round((100 + Math.floor(((number - 1) / (99 - 1) * (900 - 100))))/100) * 100

	value = <Text style={{ color: color, fontWeight: cap+'', textAlign: 'center' }}>{number}</Text>

	return value;
}
export default heatmap